import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import React from 'react'
import styled, { keyframes } from 'styled-components'

const slideUpAndFade = keyframes`
0% {
    opacity: 0;
    transform: translateY(15px);
}
100% {
    opacity: 1;
    transform: translateY(0);
}
`

const slideRightAndFade = keyframes`
0% {
    opacity: 0;
    transform: translateX(-15px);
}
 
100% {
    opacity: 1;
    transform: translateX(0);
}
`

const slideDownAndFade = keyframes`
0% {
    opacity: 0;
    transform: translateY(-15px);
}
100% {
    opacity: 1;
    transform: translateY(0);
}
`

const slideLeftAndFade = keyframes`
0% {
    opacity: 0;
    transform: translateX(15px);
}
100% {
    opacity: 1;
    transform: translateX(0);
}
`

const StyledContent = styled(TooltipPrimitive.Content)`
  z-index: 10010;
  max-width: min(360px, var(--radix-tooltip-content-available-width, 60vw));
  border-radius: 5px;
  padding: 12px 15px;
  font-size: 12px;
  font-family: Manrope;
  line-height: 1.4;
  color: white;
  background-color: ${({ theme }) => theme.colors.grayscale[800]};
  box-shadow:
    hsl(206 22% 7% / 35%) 0px 10px 38px -10px,
    hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
  user-select: none;

  @media (prefers-reduced-motion: no-preference) {
    animation-duration: 0.3s;

    will-change: transform, opacity;
    &[data-state='delayed-open'] {
      &[data-side='top'] {
        animation-name: ${slideUpAndFade};
      }
      &[data-side='right'] {
        animation-name: ${slideRightAndFade};
      }
      &[data-side='bottom'] {
        animation-name: ${slideDownAndFade};
      }
      &[data-side='left'] {
        animation-name: ${slideLeftAndFade};
      }
    }
  }
`

const StyledArrow = styled(TooltipPrimitive.Arrow)`
  fill: ${({ theme }) => theme.colors.grayscale[800]};
`

const Content: React.FC<TooltipPrimitive.TooltipContentProps> = ({
  children,
  ...props
}) => {
  return (
    <TooltipPrimitive.Portal>
      <StyledContent {...props}>
        {children}
        <StyledArrow />
      </StyledContent>
    </TooltipPrimitive.Portal>
  )
}

// Exports
export const Provider = TooltipPrimitive.Provider
export const Tooltip = TooltipPrimitive.Root
export const TooltipTrigger = TooltipPrimitive.Trigger
export const TooltipContent = Content
